import React, { useState, useEffect } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Box, Typography } from '@mui/material'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

const COLORS = [
  '#0E9BD5',
  '#0C384E',
  '#ff7f0e',
  '#d62728',
  '#5D1958',
  '#45a893',
  '#934111',
  '#4BA42E',
]

const DonutChart = ({ data = [] }) => {
  const [visibility, setVisibility] = useState(data.map(() => true))

  useEffect(() => {
    if (data.length) {
      setVisibility(data.map(() => true))
    }
  }, [data])

  const totalValue = data.reduce(
    (acc, item, index) => acc + (visibility[index] ? item.value : 0),
    0
  )

  const chartData = {
    labels: data.map((item, index) => (visibility[index] ? item.name : '')),
    datasets: [
      {
        data: data.map((item, index) => (visibility[index] ? item.value : 0)),
        backgroundColor: data.map((_, index) => COLORS[index % COLORS.length]),
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  }

  const options = {
    responsive: true,
    cutout: '60%',
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.label}: ${tooltipItem.raw}`,
        },
      },
      datalabels: {
        color: '#fff',
        formatter: (value, ctx) => {
          const dataIndex = ctx.dataIndex
          return visibility[dataIndex] ? value : ''
        },
        font: {
          weight: 'bold',
        },
      },
      centerText: {
        text: totalValue,
        color: '#333',
        fontStyle: 'bold',
        fontSize: '20px',
      },
    },
  }

  const toggleVisibility = (index) => {
    setVisibility((prev) => {
      const newVisibility = [...prev]
      newVisibility[index] = !newVisibility[index]
      return newVisibility
    })
  }

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height='100%'>
      {/* Left Box */}
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        maxWidth='50%'
        marginRight='50px'>
        {/* Title */}
        <Typography
          variant='h6'
          sx={{
            color: '#F6764E',
            fontFamily: '"Work Sans", sans-serif',
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: 'normal',
            marginBottom: '5px',
          }}>
          Associates By Grade
        </Typography>

        {/* Donut Chart */}
        <Box width={170} height={170}>
          <Doughnut data={chartData} options={options} />
        </Box>
      </Box>

      {/* Right Box */}
      <Box
        display='flex'
        flexDirection='column'
        padding='10px'
        sx={{
          maxHeight: '200px',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#AAB4C6',
            borderRadius: '10px',
            border: '2px solid #f1f1f1',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#555',
          },
        }}>
        {data.map((entry, index) => (
          <Box
            key={index}
            display='flex'
            alignItems='center'
            mb={1}
            onClick={() => toggleVisibility(index)}
            sx={{ cursor: 'pointer' }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                backgroundColor: COLORS[index % COLORS.length],
                opacity: visibility[index] ? 1 : 0.3,
                marginRight: 1,
                flexShrink: 0,
              }}
            />
            <Typography
              variant='body2'
              sx={{
                fontFamily: 'Work Sans',
                fontSize: '14px',
                color: '#333',
                opacity: visibility[index] ? 1 : 0.3,
              }}>
              {entry.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default DonutChart
